import React from "react";
import { Card, CardContent } from "ui/components/card";
import { ScatterChartContainer } from "./chart/scatter-chart-container";

const DepartmentScatterChart = ({
  departmentData = [],
  orgData = null,
  loading = false,
  isError = false,
  error = null,
}) => {
  return (
    <Card className="w-full">
      <CardContent>
        <ScatterChartContainer
          departmentData={departmentData}
          orgData={orgData}
          loading={loading}
          isError={isError}
          error={error}
        />
      </CardContent>
    </Card>
  );
};

export default DepartmentScatterChart;
